import { IEditableFormatObject } from "../../../../../../domain/editableFormat";
import { IXElementContentsObjectBean } from "../../../beans";

export class FixedValueTranslator<TValueOfObject, TValueOfBean> {
  constructor(private readonly _valueOfObject: TValueOfObject, private readonly _valueOfBean: TValueOfBean) {
  }

  from(bean?: IXElementContentsObjectBean): TValueOfObject {
    return this._valueOfObject;
  }

  to(object?: IEditableFormatObject): TValueOfBean {
    return this._valueOfBean;
  }
}
